import React, { useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import "../css/admin.css";

function AdminPage() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const ref = doc(db, "app-settings", "app-settings");
      const snap = await getDoc(ref);

      if (!snap.exists()) {
        setError("Settings not found");
        setLoading(false);
        return;
      }

      const adminPassword = snap.data().password;

      if (password !== adminPassword) {
        setError("Password is incorrect");
        setLoading(false);
        return;
      }

      // Base64 encode + store in session
      sessionStorage.setItem("adminAuth", btoa(password));

      setLoading(false);
      window.location.href = "/admin/users-details"; 
    } catch (err) {
      console.error(err);
      setError("Something went wrong");
      setLoading(false);
    }
  };

  return (
    <div className="admin-container">
      <form className="admin-card" onSubmit={handleSubmit}>
        <h2 className="admin-title">Admin Login</h2>

        <input
          type="password"
          className="admin-input"
          placeholder="Enter Admin Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        {error && <p className="admin-error">{error}</p>}

        <button className="admin-button" disabled={loading}>
          {loading ? "Checking..." : "Login"}
        </button>
      </form>
    </div>
  );
}

export default AdminPage;
